<script>
    import html2canvas from 'html2canvas';
    import { onMount } from 'svelte';
    import MapLoading from '../../../../../shared/components/common/Loading/MapLoading.svelte';
    import Area from '../../../../../shared/models/Area/Area';
    import { userSession } from '../../../../../shared/stores';

    export let customClass = '';

    export let indirizziDipendenti = [];
    export let sede = {};
    export let mapScreenshot = '';

    let map;
    let mapContainer;
    let loadingMap = true;
    let mapDataReady = false;
    let initialZoom = 7;
    let coords = [0, 0];

    const [dataArea, loadingArea, errorArea] = Area.get($userSession.areaId);

    $: {
        if ($userSession.areaId && $dataArea && $dataArea.id) {
            if ($dataArea.mapZoom) {
                initialZoom = $dataArea.mapZoom;
            }
            if ($dataArea.mapLatitude && $dataArea.mapLongitude) {
                coords = [$dataArea.mapLatitude, $dataArea.mapLongitude];
            }
            mapDataReady = true;
        }
    }

    function createSvgIcon(color, icon) {
        var svgElement = `
                        <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
                            <path d="M15.6,1c-7.7,0-14,6.3-14,14c0,10.5,14,26,14,26s14-15.5,14-26C29.6,7.3,23.3,1,15.6,1z" fill="${color}" stroke="black" stroke-width="1"></path>
                            <g transform="translate(3.4, 5)">
                                ${icon}
                            </g>
                        </svg>
                        `;

        return L.divIcon({
            className: 'svg-icon',
            iconSize: [31, 42],
            html: svgElement
        });
    }

    var personIcon = createSvgIcon('#3388ff', '<path fill="white" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>');
    var domainIcon = createSvgIcon('#FF0000', '<path fill="white" xmlns="http://www.w3.org/2000/svg" d="M12,7V3H2v18h20V7H12z M6,19H4v-2h2V19z M6,15H4v-2h2V15z M6,11H4V9h2V11z M6,7H4V5h2V7z M10,19H8v-2h2V19z M10,15H8v-2h2 V15z M10,11H8V9h2V11z M10,7H8V5h2V7z M20,19h-8v-2h2v-2h-2v-2h2v-2h-2V9h8V19z M18,11h-2v2h2V11z M18,15h-2v2h2V15z"/>');


    onMount(() => {
        let initAttempts = 0;
        const maxAttempts = 5;

        const initMap = () => {
            if (mapDataReady && mapContainer) {
                try {
                    loadingMap = false;

                    map = L.map(mapContainer, {
                        renderer: L.canvas()
                    });

                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

                    let allCoordinates = [];

                    indirizziDipendenti.forEach((indirizzo) => {
                        const lat = parseFloat(indirizzo.latitude);
                        const lon = parseFloat(indirizzo.longitude);
                        if (!isNaN(lat) && !isNaN(lon)) {
                            L.marker([lat, lon], { icon: personIcon }).addTo(map);
                            allCoordinates.push([lat, lon]);
                        }
                    });
                    
                    const lat = parseFloat(sede.latitude);
                    const lon = parseFloat(sede.longitude);
                    
                    if (!isNaN(lat) && !isNaN(lon)) {
                        L.marker([lat, lon], { icon: domainIcon }).addTo(map);
                        allCoordinates.push([lat, lon]);
                    }

                    if (coords[0] !== 0 || coords[1] !== 0) {
                        map.setView(coords, initialZoom);
                    } else if (allCoordinates.length > 0) {
                        map.fitBounds(allCoordinates, { padding: [60, 60] });
                    } else {
                        map.setView([0, 0], 2);
                    }                    
                } catch (error) {
                    console.error("Error initializing map:", error);
                    loadingMap = false;
                }
            } else {
                initAttempts++;
                if (initAttempts < maxAttempts) {
                    setTimeout(initMap, 2000);
                } else {
                    console.error("Max attempts reached. Unable to initialize map.");
                    loadingMap = false;
                }
            }
        };

        initMap();
    });

    export async function getMapScreenshot() {
        if (loadingMap) {
            await new Promise((resolve) => {
                const checkReady = setInterval(() => {
                    if (!loadingMap) {
                        clearInterval(checkReady);
                        resolve();
                    }
                }, 100);
            });
        }

        return new Promise((resolve, reject) => {
            const attribution = document.querySelector('.leaflet-control-attribution');
            const zoom = document.querySelector('.leaflet-control-zoom');

            if (attribution) attribution.style.display = 'none';
            if (zoom) zoom.style.display = 'none';

            setTimeout(() => {
                html2canvas(document.getElementById("map"), {
                    allowTaint: false, 
                    useCORS: true
                }).then(async function(canvas) {
                    mapScreenshot = await canvas.toDataURL();
                    
                    if (attribution) attribution.style.display = '';
                    if (zoom) zoom.style.display = '';

                    resolve();
                }).catch(reject);
            }, 500);
        });
    }
</script>

<style>
    #map {
        height: 500px;
        width: 100%;
    }

    :global(.material-icons) {
        font-size: 21px;
    }
</style>

{#if loadingMap}
    <MapLoading />
{/if}

<div bind:this={mapContainer} id="map" class={customClass}></div>